import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
    name: 'defaultIfEmpty',
    standalone: false
})
export class DefaultIfEmptyPipe implements PipeTransform {
  transform(value: string, defaultValue: string): string {
    return value ? value : defaultValue;
  }
}
